import request from '../utils/request'
import { getQuickToken } from '../utils/auth'

// 注册(暂未使用)
export function register(params) {
  return request({
    url: '/auth/customerRegister',
    headers: {
      isToken: false
    },
    method: 'post',
    data: params
  })
}

// 登录
export function login(params) {
  return request({
    url: '/auth/customerRegister',
    headers: {
      isToken: false
    },
    method: 'post',
    data: params
  })
}

// 代理登录
export function agentLogin(params) {
  return request({
    url: '/lms/agent/agentLogin',
    headers: {
      isToken: true,
      Authorization: 'Bearer ' + getQuickToken()
    },
    method: 'post',
    data: params
  })
}


// 退出登录
export function logout() {
  return request({
    url: '/auth/customerLogout',
    headers: {
      isToken: false
    },
    method: 'post',
    data: {}
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/code',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

// 发送短信
export function getCode(data) {
  return request({
    url: '/auth/getCode',
    headers: {
      isToken: false
    },
    method: 'post',
    data
  })
}

// 微信公众号获取 access_token
export function getAccessToken() {
  return request({
    url: 'https://api.weixin.qq.com/cgi-bin/token?grant_type=client_credential&appid=wxc00fa5c747bb116f&secret=c6b9ab6cd32b702f09f6a75a7c36f452',
    method: 'get',
    data: {}
  })
}


// 微信公众号获取用户信息
export function getUserInfo(data) {
  return request({
    url: 'https://api.weixin.qq.com/cgi-bin/user/info?access_token='+ data.access_token +'&openid='+ data.openid +'&lang=zh_CN',
    method: 'get',
    data: {}
  })
}

// 查询客服审核状态
export function getExamineInfo(shopCode) {
  return request({
    url: '/shop/examine/selectExamineInfoByPar?shop=' + shopCode,
    method: 'get',
    data: {}
  })
}

// 查询当前用户账号名
export function getLoginUser() {
  return request({
    url: '/user/basic/getLoginUser',
    method: 'get',
    data: {}
  })
}

// 获取用户密码
export function getPassword(shopCode) {
  return request({
    url: '/shop/check/wait?shopCode=' + shopCode,
    method: 'get',
    data: {}
  })
}

// 获取腾讯地图
export function getGeoCode(query) {
  return request({
    url: '/sdk/Qmap/geocode',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/user.js